import { PAGE_ROUTES, USER_TYPES } from "@/config/constants";
import { getMetadata } from "@/features/metadata/metadataSlice";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SearchIcon from "@mui/icons-material/Search";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export const FooterSection = () => {
  const router = useRouter();
  const metadata = useSelector(getMetadata);

  const redirectToOrderTracking = () => {
    if (
      metadata.userType === USER_TYPES.AGENT ||
      metadata.userType === USER_TYPES.RETENTION
    ) {
      router.push("/order-tracking");
    }
  };
  const redirectToHome = () => {
    if (
      metadata.userType === USER_TYPES.AGENT ||
      metadata.userType === USER_TYPES.RETENTION
    ) {
      router.push(PAGE_ROUTES.MEMBERS);
    }
  };
  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "background.secondary",
        display: { xs: "block", sm: "block", md: "none" },
        zIndex: 1000,
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        sx={{ bgcolor: "background.secondary", color: "color.aigColor64" }}
      >
        <BottomNavigationAction
          label="Home"
          sx={{ color: "inherit" }}
          icon={<HomeIcon />}
          onClick={redirectToHome}
        />
        <BottomNavigationAction
          label="Order Tracking"
          sx={{ color: "inherit" }}
          icon={<SearchIcon />}
          onClick={redirectToOrderTracking}
        />
        <BottomNavigationAction
          label="Nearby"
          sx={{ color: "inherit" }}
          icon={<NotificationsIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};
